<template>
	<modal :isOpen="isOpen">
		<template v-slot:body>
			<div class="title">Not planning on looking back?</div>
			<div class="discount">
				<p>Based on your answers, you’re ready to make changes for good.</p>

				<p>
					Get a head start and take
					<b>63% off your total</b>
					for skipping the trial and starting today!
				</p>
			</div>
			<button @click="$emit('upgrade')" class="btn btn-block btn-pink-gradient">SKIP TRIAL AND START PLAN</button>
			<button @click="$emit('skip')" class="btn btn-block btn-color-gray">continue with TRIAL</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
	components: {
		Modal
	},
	props: {
		isOpen: {
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	text-align: center;
	font-weight: bold;
	font-size: 2rem;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	line-height: 1.3;
}

.discount {
	font-size: 1.2rem;
	text-align: center;
	margin-bottom: 1.8rem;
	line-height: 1.3;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;

	b {
		display: block;
		font-size: 2rem;
		color: #6b7ae5;
		margin: 4px 0;
	}
}

.btn-color-gray {
	margin-top: 0.7rem;
}
</style>
